export enum MachineServiceCardType {
  SERVICE = 'service',
  PART = 'part',
  LIQUID = 'liquid'
}
